export default {
	properties: [
		{
			text: 'Porcentaje',
			key: 'percentage',
			type: 'number',
		},
	],
	singular_model_name_spanish: 'Descuento',
	plural_model_name_spanish: 'Descuentso',
	create_model_name_spanish: 'Nuevo Descuento',
	text_delete: 'el',
}